const DOCS_BUCKET = 'driver-documents';

export const DRIVER_DOCUMENT_FIELDS = {
  license_front: { column: 'license_image_url', folder: 'license' },
  license_back: { column: 'license_back_image_url', folder: 'license-back' },
  aadhaar_front: { column: 'aadhaar_image_url', folder: 'aadhaar' },
  aadhaar_back: { column: 'aadhaar_back_image_url', folder: 'aadhaar-back' },
  profile: { column: 'driver_photo_url', folder: 'photo' },
  selfie: { column: 'license_selfie_url', folder: 'license-selfie' },
  rc: { column: 'rc_image_url', folder: 'rc' },
  insurance: { column: 'insurance_image_url', folder: 'insurance' },
  inspection: { column: 'inspection_form_url', folder: 'inspection' },
};

function normalizePhone(value) {
  const digits = String(value || '').replace(/\D/g, '');
  if (digits.length === 12 && digits.startsWith('91')) return digits.slice(2);
  if (digits.length === 11 && digits.startsWith('0')) return digits.slice(1);
  return digits;
}

export async function uploadDriverDocument(supabaseClient, { phone, folder, file }) {
  if (!supabaseClient || !file) {
    return { url: null, error: 'Missing file or storage.' };
  }
  const ext = file.name.split('.').pop()?.toLowerCase() || 'jpg';
  const safeExt = ['jpg', 'jpeg', 'png', 'webp'].includes(ext) ? ext : 'jpg';
  const phoneKey = normalizePhone(phone) || 'driver';
  const unique = `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
  const path = `admin/${folder}/${unique}-${phoneKey}.${safeExt}`;

  const { error: uploadError } = await supabaseClient.storage
    .from(DOCS_BUCKET)
    .upload(path, file, {
      cacheControl: '3600',
      upsert: false,
      contentType: file.type || `image/${safeExt}`,
    });

  if (uploadError) {
    const msg = uploadError.message || 'Upload failed.';
    const hint = /bucket|not found|policy/i.test(msg)
      ? ' Check driver-documents storage policies in Supabase.'
      : '';
    return { url: null, error: msg + hint };
  }

  const { data } = supabaseClient.storage.from(DOCS_BUCKET).getPublicUrl(path);
  return { url: data.publicUrl, error: '' };
}

async function updateDriverById(supabaseClient, driverId, payload) {
  if (!supabaseClient || !driverId) {
    return { data: null, error: 'Missing driver.' };
  }
  const { data, error } = await supabaseClient
    .from('drivers')
    .update(payload)
    .eq('id', driverId)
    .select('*')
    .single();

  if (error) {
    return { data: null, error: error.message || 'Could not save document.' };
  }
  return { data, error: '' };
}

export async function saveDriverDocumentUrl(supabaseClient, driverId, docId, url) {
  const meta = DRIVER_DOCUMENT_FIELDS[docId];
  if (!meta) return { data: null, error: 'Unknown document type.' };
  return updateDriverById(supabaseClient, driverId, { [meta.column]: url });
}
